module.exports = __webpack_public_path__ + "img/icon7.8f8657d5.png";